import { createActionsHook } from 'src/lib/sweetState';

import { SystemStore } from './SystemStore';

export const useSystemActions = createActionsHook(SystemStore);
